// @flow

import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import './style.css';

function Footer() {
    const today = new Date();

    return (
        <Grid
            container
            className="app-footer"
            spacing={0}
            direction="column"
            alignItems="center"
            justify="center"
        >
            <Grid item sm={12} md={12} lg={12}>
                <Typography className="copy-right">
                    &copy; {today.getFullYear()} SurePrep LLC. All rights
                    reserved.
                </Typography>
            </Grid>
        </Grid>
    );
}

export default Footer;
